export const text = {
  message: "have requested to Seller Account",
  sellerRequest: "Seller Requests",
  productRequests: "Product Requests",
};
